export default __webpack_public_path__ + "e9b5f4e8b75290615df079b50288d6c1.svg";